export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_TIME_FORMAT = 'HH:mm a'
export const API_TIME_FORMAT = 'hh:mm:ss'
export const DEFAULT_DATETIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
